import {GameElementType} from "../../types/gameSession";
import { useState } from 'react';

interface Props {
    element: GameElementType;
}

const GameElement = ({element}: Props) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    switch (element.type) {
        case 'element_title':
            return <div className='only-title'><h1>{element.title}</h1></div>;
        case 'element_image':
            return (
                <>
                    <img
                        className={`element_image ${imageLoaded ? 'loaded' : ''}`}
                        src={element.content}
                        alt={element.title}
                        onLoad={() => setImageLoaded(true)}
                    />
                </>
            );
        default:
            return null;
    }
};

export default GameElement;